import * as React from 'react';
import {Container, Image} from "react-bootstrap";
import {Link} from "react-scroll"

export function Header({opacity}) {

    const menuItems = [
        {label: 'Home', target: "home", offset: -60},
        {label: 'Rólunk', target: "about", offset: -20},
        {label: 'Előnyök', target: "pro", offset: 300},
        {label: 'Hogyan?', target: "how", offset: -80},
        {label: 'Kapcsolat', target: "contacts", offset: 0},
    ]

    return (
        <Container
            className="header-container d-flex flex-row justify-content-center align-items-center py-3 gap-3"
            fluid
            style={{opacity, backgroundColor: 'white'}}
        >
            <Image
                className="header-logo my-2"
                src="/assets/EccoPresso_logo_pod_start.svg"
            />
            {menuItems.map(item => (
                <Link
                    containerId="main"
                    to={item.target}
                    smooth={true}
                    spy={true}
                    offset={item.offset}
                    duration={2000}
                    style={{cursor: "pointer"}}
                >
                    <span>{item.label}</span>
                </Link>

            ))}
        </Container>
    );
}